import { GridCellKind, type CustomCell, type CustomRenderer } from '@glideapps/glide-data-grid'

import { CustomGridCellKind } from '@/components/GridV2/helpers/CustomGridCellKind'

interface SpinnerCellProps {
  readonly kind: 'spinner-cell'
}

export type SpinnerCell = CustomCell<SpinnerCellProps>

const SpinnerRenderer: CustomRenderer<SpinnerCell> = {
  kind: GridCellKind.Custom,
  isMatch: (cell: CustomCell): cell is SpinnerCell => (cell.data as any).kind === CustomGridCellKind.Spinner,
  draw: (args) => {
    const { ctx, theme, rect, requestAnimationFrame } = args

    // Use a shared timestamp to avoid multiple calls to performance.now()
    const now = window.performance.now()
    const progress = (now % 1000) / 1000

    // Pre-calculate dimensions once
    const x = rect.x + rect.width / 2
    const y = rect.y + rect.height / 2
    const radius = Math.min(12, rect.height / 6)
    
    // Only redraw when visible (optimization)
    if (rect.width <= 0 || rect.height <= 0) {
      return true
    }

    // Save and restore context to avoid state leakage
    ctx.save()
    
    ctx.beginPath()
    ctx.arc(x, y, radius, Math.PI * 2 * progress, Math.PI * 2 * progress + Math.PI * 1.5)

    ctx.strokeStyle = theme.textMedium
    ctx.lineWidth = 1.5
    ctx.stroke()
    
    ctx.restore() // Restore canvas state
    
    requestAnimationFrame()

    return true
  },
  provideEditor: () => undefined,
}

export default SpinnerRenderer
